import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <p className="text-sm tracking-widest uppercase text-slate-500">
                    Loading…
                </p>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
